// extracted by mini-css-extract-plugin
export default {"qrCode":"barcode_qrCode__b-NyI"};